import React from "react";
import CordwoodListItem from "../../components/cordwood/CordwoodList/CordwoodListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const CordwoodListPage = ()  => {

    useTitle(t`List Cordwood`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <CordwoodListItem showAdd={true} {...query} />
        </Box>
    )
}

export default CordwoodListPage;
